import CustomerIncidents from "../components/Customer/CustomerIncidents";
import CustomerChanges from "../components/Customer/CustomerChanges";
import CustomerLicenses from "../components/Customer/CustomerLicenses";
import {
  companyDevices,
  customerChanges,
  customerIncidents,
  customerLicences,
  customerexistsarrow,
  customerexistspax8,
  customerexiststimechimp,
  customerexiststopdesk,
} from "../endpoints";
import useFetch from "../hooks/useFetch";

interface Props {
  name: string;
}
interface device {
  id: string;
}
interface incident {
  number: string;
}
interface change {
  number: string;
}
interface licence {
  name: string;
}
interface topdesk {
  exists: string;
}
interface timechimp {
  exists: string;
}
interface arrow {
  exists: string;
}
interface pax8 {
  exists: string;
} 

// interface exist {
//   topdesk: string;
//   projects: string;
//   arrow: string;
//   pax8: string;
// }

const CustomerLayout = ({ name }: Props) => {
  const { data: devicesData} = useFetch<device>(
    companyDevices,
    { companyName: name }
  );

  const { data: incidentsData} = useFetch<incident>(
    customerIncidents,
    { companyName: name }
  );

  const { data: changesData} = useFetch<change>(
    customerChanges,
    { companyName: name }
  );

  const { data: licencesData} = useFetch<licence>(
    customerLicences,
    { companyName: name }
  );

  const {data: existsTopdesk} = useFetch<topdesk>(
    customerexiststopdesk,
    { companyName: name }
  );

  const {data: existsTimechimp} = useFetch<timechimp>(
    customerexiststimechimp,
    { companyName: name }
  );

  const {data: existsArrow} = useFetch<arrow>(
    customerexistsarrow,
    { companyName: name }
  );

  const {data: existsPax8} = useFetch<pax8>(
    customerexistspax8,
    { companyName: name }
  );

  console.log("data stuff:",existsTopdesk, existsTimechimp, existsArrow, existsPax8)
  console.log("topdesk:", existsTopdesk)
  console.log("timechimp:", existsTimechimp)
  console.log("arrow:", existsArrow)
  console.log("pax8:", existsPax8)

  const show = (value: unknown) =>
    typeof value === "string"
      ? value
      : Array.isArray(value)
      ? (typeof value[0] === "string" ? value[0] : (value[0] as any)?.exists)
      : (value as any)?.exists;
  

  // const { data: existData} = useFetch<exist>(
  //   customersExistList,
  //   { companyName: name }
  // );

  // console.log(existData)

  // const firstExist = existData?.[0] || { topdesk: '-', projects: '-', arrow: '-', pax8: '-' };

  return (
    <div className="w-full flex flex-col items-center">
      <div className="flex w-full ml-28">
        <div className="flex bg-white rounded-lg p-3 mr-8">
          <div className="flex flex-col">
            <b>Topdesk: </b>
            <b>Timechimp: </b>
            <b>Arrow: </b>
            <b>Pax8: </b>
          </div>
          <div className="flex flex-col ml-5">
            <p>{show(existsTopdesk)}</p>
            <p>{show(existsTimechimp)}</p>
            <p>{show(existsArrow)}</p>
            <p>{show(existsPax8)}</p>
          </div>
        </div>
        <div className="flex bg-white rounded-lg p-3">
          <div className="flex flex-col">
            <b>Meldingen: </b>
            <b>Wijzigingen: </b>
            <b>Licenties: </b>
            <b>Devices: </b>
          </div>
          <div className="flex flex-col ml-5">
            <p>{incidentsData.length}</p>
            <p>{changesData.length}</p>
            <p>{licencesData.length}</p>
            <p>{devicesData.length}</p>
          </div>
        </div>
      </div>
      

      {/* Incidents */}
      <div className="flex justify-center w-[90%]">
        <CustomerIncidents name={name} />
      </div>

      {/* Changes */}
      <div className="flex justify-center w-[90%]">
        <CustomerChanges name={name} />
      </div>

      {/* Licenses */}
      <div className="flex justify-center w-[90%]">
        <CustomerLicenses name={name} />
      </div>
    </div>
  );
};

export default CustomerLayout;
